import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-describedby"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 1,
  class: "wc-product-price-v2-card__see-in-cart"
}
const _hoisted_5 = ["aria-describedby"]
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 3,
  class: "wc-product-price-v2-card__in-cart-discount"
}
const _hoisted_8 = {
  key: 4,
  class: "wc-product-price-v2-card__call-for-price"
}

import { computed } from 'vue';
import ItemSummary from '@/models/entities/items/item-summary';
import useItemPrice from '@/composables/useItemPrice';
import usePlatform from '@/modules/platform/composables/usePlatform';
import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';
import WCSvgIcon from '@/components/WCSvgIcon/WCSvgIcon.vue';
import useHidePricing from '@/composables/useHidePricing';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCProductPriceCardModern',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const itemRef = computed(() => props.item);
const { t } = useI18n();

const {
  isAdditionalScanCode,
  hasActualPrice,
  isSoldByAverageWeight,
  isDiscounted,
  hasBuyDown,
  actualPriceDisplay,
  suggestedPriceDisplay,
  estimatedEachDisplay,
  avgWeightTooltipEstimate,
} = useItemPrice(itemRef);

const { shouldHideItemPrices } = useHidePricing();

const { platform } = usePlatform();

const isSaleWithoutBuyDown = computed(() => isDiscounted.value && !hasBuyDown.value);

const platformModifier = computed(() =>
  platform.value.isMobile
    ? 'wc-product-price-v2-card--mobile'
    : 'wc-product-price-v2-card--desktop',
);

return (_ctx: any,_cache: any) => {
  return (!_unref(shouldHideItemPrices))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wc-product-price-v2-card", platformModifier.value])
      }, [
        (_unref(hasActualPrice) && !_unref(isAdditionalScanCode))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["wc-product-price-v2-card__actual", {
        'wc-product-price-v2-card__actual--sale': isSaleWithoutBuyDown.value,
        'wc-product-price-v2-card__actual--sale-avg-weight':
          _unref(isSoldByAverageWeight) && isSaleWithoutBuyDown.value,
      }]),
              "aria-describedby": `${itemRef.value.id}-priceDesc`
            }, [
              _createTextVNode(_toDisplayString(_unref(actualPriceDisplay)) + " ", 1),
              (_unref(isSoldByAverageWeight))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'wc-product-price-v2-card__sale-estimate': isSaleWithoutBuyDown.value })
                    }, _toDisplayString(_unref(estimatedEachDisplay)), 3),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", {
                      ref: "avgWeightIcon",
                      class: _normalizeClass(["wc-product-price-v2-card__avg-icon", { 'wc-product-price-v2-card__avg-icon--sale': isSaleWithoutBuyDown.value }])
                    }, [
                      _createVNode(WCToolTip, {
                        target: "avgWeightIcon",
                        position: "top",
                        class: "wc-product-price-v2-card__avg-tooltip"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('priceMayVaryWhenWeighed')), 1),
                          _cache[0] || (_cache[0] = _createTextVNode()),
                          _createElementVNode("div", null, _toDisplayString(_unref(avgWeightTooltipEstimate)), 1)
                        ]),
                        _: 1
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode()),
                      _createVNode(WCSvgIcon, {
                        name: "circle-info",
                        "icon-size": { widthRem: 0.75, heightRem: 0.75 }
                      })
                    ], 2),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("span", {
                      class: "sr-only",
                      id: `${itemRef.value.id}-avgPriceText`
                    }, _toDisplayString(_unref(t)('averagePerUnitPrice')), 9, _hoisted_2)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createElementVNode("span", {
                class: "sr-only",
                id: `${itemRef.value.id}-priceDesc`
              }, _toDisplayString(_unref(isDiscounted) ? _unref(t)('salePrice') : _unref(t)('productPrice')), 9, _hoisted_3)
            ], 10, _hoisted_1))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (_unref(isAdditionalScanCode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('seePriceInCart')), 1))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createTextVNode()),
        (_unref(hasActualPrice) && isSaleWithoutBuyDown.value && !_unref(isAdditionalScanCode))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "wc-product-price-v2-card__strikethrough",
              "aria-describedby": `${itemRef.value.id}-priceText`
            }, [
              _createElementVNode("s", null, _toDisplayString(_unref(suggestedPriceDisplay)), 1),
              _cache[5] || (_cache[5] = _createTextVNode()),
              _createElementVNode("span", {
                class: "sr-only",
                id: `${itemRef.value.id}-priceText`
              }, _toDisplayString(_unref(t)('productPrice')), 9, _hoisted_6)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createTextVNode()),
        (_unref(hasActualPrice) && !_unref(isAdditionalScanCode) && _unref(hasBuyDown))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('discountAppliedInCartPdp')), 1))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createTextVNode()),
        (!_unref(hasActualPrice) && !_unref(isAdditionalScanCode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('callForPrice')), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})